import React from "react";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import { addDecrement, editDecrement } from "../../Requests/deltaHedgeSettings";
import { toast } from "react-toastify";
import {
  addEditDecrementalFormValuesChangeHandler,
  setAddEditDecrementalFormValues,
  setDecrementalEditFlag,
  setDecrementalTableFlag,
  setHeltaHedgeSettingsAddEditModalFlag,
} from "../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";
import { IDecrementalTableReport } from "../../Interfaces/deltaHedgeSettings";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import TextInput from "../../Components/TextInput";
import CheckBox from "../../Components/Checkbox";
import Button from "../../Components/Button";

const AddDecremental = () => {
  const formValues = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice
  ).addEditDecrementalFormValues;

  const dispatch = useAppDispatch();

  const isEdit = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.decrementalEditFlag
  );

  const getProperFunction = () => {
    if (isEdit) return editDecrement(formValues);
    return addDecrement(formValues);
  };

  const addHandler = () => {
    getProperFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);

          dispatch(
            setAddEditDecrementalFormValues({} as IDecrementalTableReport)
          );

          if (isEdit) dispatch(setDecrementalEditFlag(false));

          dispatch(setDecrementalTableFlag(true));
          dispatch(setHeltaHedgeSettingsAddEditModalFlag(false));
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const changeHandler = (name: string, value: any) => {
    dispatch(addEditDecrementalFormValuesChangeHandler({ name, value }));
  };

  return (
    <>
      <DynamicDropdown
        dropdown={{
          name: "baseInsId",
          placeholder: "نماد پایه",
          extraLabel: true,
        }}
        onChange={changeHandler}
        getData={() => getBaseInstruments()}
        value={formValues.baseInsId}
      />

      <TextInput
        label="حداقل حباب"
        name="minBubble"
        value={formValues.minBubble?.toString()}
        kind="number"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="مارجین"
        name="margin"
        value={formValues.margin?.toString()}
        kind="percent"
        onChange={changeHandler}
        extraLabel
      />

      <CheckBox
        label="مجاز به فروش سهم پایه"
        name="canSellBaseIns"
        checked={formValues.canSellBaseIns}
        onChange={changeHandler}
      />

      <Button
        text={isEdit ? "ویرایش" : "ثبت"}
        onClick={addHandler}
        variant="contained"
      />
    </>
  );
};

export default AddDecremental;
